import React, { useMemo, useState } from 'react'
import { Wrapper, ListItem, TextDetail, Panel, TextField } from '../_components'
// import Table from '../_components/Table'
import Axios from 'axios'
// import Theme from '../Theme'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { FaAddressCard } from 'react-icons/fa'
// import { setVerifyModal } from '../_slices/AppSlice'
import avatar from '../_images/avatar.png'
import Actions from './DisplayRecord/Actions'

const menuItems = [ 
    "Applicant Particulars",
    "Location Particulars",
    "Business Particulars",
    "Attachments", 
    "Comments",
    "Action"
]

const ValField = record => {
  if(  record.value instanceof Array ) {
    return (
      <div>{`1`}</div>
    )
  }
  else {
    return (
      <div className="text-gray-500">
        {record.value}
      </div>
    )
  }
}

export default function () {

  const dispatch = useDispatch()
//   const navigate = useNavigate()

  const state = useSelector( state => {
    return {
      verifyFlag: state.application.verifyModal?.verifyFlag,
      title: state.application.verifyModal?.title,
    }
  } )
  const Columns = useMemo( () => 
  [
    {
      Header: "Parameter",
      accessor: "label",
      sortable: false
    },
    {
      Header: "Information",
      accessor: "value",
      sortable: false,
      Cell: ValField
    }
  ] )

  const DefaultColumns = useMemo( () => 
  [
    {
      Header: "Parameter",
      accessor: "label",
      sortable: false
    },
    {
      Header: "Information",
      accessor: "value",
      sortable: false,
      Cell: ValField
    },
    {
      Header: "Attachment",
      accessor: "attachment",
      sortable: false
    },
    {
      Header: "Status",
      accessor: "attachment_status",
      sortable: false
    },

  ] )

  const [ loading, setLoading ] = React.useState( true )
  const [ record, setRecord ] = useState( null )
  const [ records, setRecords ] = React.useState( [] )
  const [ recordsDefault, setDefaultRecords ] = React.useState( [] )
  const [ resultsDefault, setResults ] = React.useState( [] )
  const [ currentLink, setCurrentLink ] = useState( "Applicant Particulars" )
  const [ remarks, setRemarks ] = useState( [] )
  const [ files, setFiles ] = useState( [] )

  React.useEffect( () => {
    if( loading ) {
      fetchApplication()
      fetchAllRemarks()
      fetchAllDocuments()
    }
  },[ loading ])

  const fetchApplication = async () => {
    try {
     const response =  await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication/${localStorage.getItem( "applicationId" )}` )
     if( response.data ) {
      setRecord( response.data.record )
      setLoading( false )
     }
    } catch (error) {
      setLoading( false )
    }
  }

  const fetchAllRemarks = async () => {
    try {
      const response  = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/getAllITRemarks`)
      if( response.data ) {
        const results  = response.data.filter( remark => {
          return parseInt( remark.parentID ) === parseInt( localStorage.getItem( "applicationId" )  );
        } )
        setRemarks( results );
      }
    } catch (error) {
      
    }
  }

  const fetchAllDocuments = async () => {
    let applicationId = localStorage.getItem( "applicationId" )
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getApplicationFiles/${applicationId}` )
      if( response.data ){
        setFiles( response.data?.data )
      }
    } catch (error) {}
  }

  const previewFile = async (e) => {
    let file_id = e.target.id

    try {
      const email = btoa(localStorage.getItem( "email" )); // Base64 encode
      const url = process.env.REACT_APP_API_URL+`/api/auth/get_file_details/${file_id}/${email}`
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } catch (error) {}
  }

  const printCertificate = async () => {
    let applicationId = localStorage.getItem( "applicationId" )
    let itcoArray = [{"3j4kndd" : applicationId}]
    let mySerializedString = JSON.stringify(itcoArray);
    try {
      const url = process.env.REACT_APP_API_URL+`/api/auth/print_certificate/${mySerializedString}`
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } catch (error) {}
  }

  const requestRenewal = async (e) => {
    let applicationId = e.target.id
    //console.log('right here for record id ==> '+applicationId);
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/renewalApplication/${applicationId}` )
      if( response.data.success === true ){
        await localStorage.setItem("link", "welcome" )
        return window.location.reload()
      }
    } catch (error) {}
  }

  return (
    <Wrapper>
        {loading ? (
            <div className="flex items-center justify h-full w-full">
                {`Loading...`}
            </div>
        )
        :(<div className="bg-gray-100 h-full overflow-y-scroll grid gap-3 px-10 py-3">
          
          <div className="h-full bg-white rounded-sm grid">
            <div className="border-b border-gray-300 flex flex-row">
              <div className="flex flex-row items-center px-2">
                {/* <button className="text-sm underline text-red-500" onClick={() => alert("back")}>Back</button> */}
                <h2 className="p-5 text-sm font-bold uppercase">
                   {`Application Details for`}
                </h2> <div className="text-blue-600 font-extrabold pb-1">{(record?.category === "Company" ? record?.entity_name : record?.trading_name)}</div>
              </div>
              <div />
            </div>

            <div className="border-b border-gray-300 p-4">
              <div className="h-full border border-gray-200 flex flex-row items-center justify-between rounded-sm">
                <div className="grid gap-2 px-2" style={{ gridTemplateRows: "1rem auto"}}>
                  <h5 className="text-start text-xs uppercase">
                    {`Applicant`}
                  </h5>
                  <div className="flex flex-row px-2">
                    <div className="rounded-full border border-gray-200 overflow-hidden flex items-center justify-center w-10 h-10">
                      <img src={avatar} alt="Profile Image" className="rounded-full" />
                    </div>
                    <div className="flex flex-col items-start justify-center px-2">
                      <p className="text-xs">
                        {/* {capitalizeName( record?.first_name + " " +  record?.surname )} */}
                      </p>
                      <p className="text-xs">
                        {/* {record?.telephone} */}
                      </p>
                      <p className="text-xs">
                        {/* {record?.email_address} */}
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="flex flex-col">
                  <TextDetail label="Created Date" val={moment( record?.created_at ).format( "DD-MMM-YYYY" )} />
                  <TextDetail label="Client Email Address" val={record?.created_by} />
                  <TextDetail label="Category" val={record?.category} />
                  <TextDetail label="Payment" val={(record?.prn_status === "C" ? "Submitted And Cleared" : "NOT CLEARED")} />
                  <TextDetail label="Application Status" val={record?.status || "ONGOING"} color="red" />
                  {( record?.status === "APPROVED" ) && 
                    ( <button type="button" className="text-xs bg-purple-700 text-white px-2 py-1" onClick={printCertificate}>
                        {`Print Certificate`}
                    </button> ) }
                </div>
                <div />
              </div>
            </div>

            <div className="w-full">
              <Panel label="Section A: Applicant Particulars">
                <div className="grid grid-cols-2 gap-2 items-center">
                    {record?.category === "Individual" && [
                        { label: "Category", value: record?.category, name: "category" },
                        { label: "Given Name/ First Name", value: record?.given_name, name: "given_name" },
                        { label: "Surname", value: record?.surname, name: "surname" },
                        { label: "Other Name", value: record?.middle_name, name: "other_name" },
                        { label: "Nationality", value: record?.nationality, name: "nationality" },
                        { label: record?.nationality === "Ugandan" ? "National ID" : "Passport No.", value: record?.nationality === "Ugandan" ? record?.national_id : record?.passport_number, name: "national_id" },
                        { label: "Taxpayer Identification Number", value: record?.tin, name: "tin" }
                    ].map( val => {
                        return (
                          <TextDetail label={val.label} val={val.value} key={val.value}/>
                        )
                    } )}

                    {record?.category === "Company" && [
                        { label: "Certification Level", value: record?.certification_level, name: "certification_level" },
                        { label: "Contact First Name", value: record?.contact_first_name, name: "contact_first_name" },
                        { label: "Contact Last Name", value: record?.contact_last_name, name: "contact_last_name" },
                        { label: "Other Name", value: record?.contact_middle_name, name: "contact_middle_name" },
                        { label: "TIN", value: record?.tin, name: "tin" },
                    ].map( val => {
                        return (
                          <TextDetail label={val.label} val={val.value} key={val.value} />
                        )
                    } )}
                </div>
              </Panel>
                
              <Panel label="Section A: Location Particulars">
                <div className="grid grid-cols-2 gap-2 items-center">
                    {[
                        { label: "District", value: record?.district, name: "district" },
                        { label: "County", value: record?.county, name: "county" },
                        { label: "Subcounty", value: record?.subcounty, name: "subcounty" },
                        { label: "Parish", value: record?.parish, name: "parish" },
                        { label: "Village", value: record?.village, name: "village" }
                    ].map( val => {
                        return (
                          <TextDetail label={val.label} val={val.value} key={val.value} />
                        )
                    } )}
                </div> 
              </Panel>

                
              <Panel label="Section B: Business Particulars">
                <div className="grid grid-cols-2 gap-2 items-center">
                  {[
                      { label: "Date of Incorporation", value: record?.doc, name: "doc" },
                      { label: "Name of Entity", value: record?.entity_name, name: "entity_name" },
                      { label: "Entity Registration", value: record?.entity_registration, name: "entity_registration" },
                      { label: "Entity Type", value: record?.entity_type, name: "entity_type" },
                      { label: "BRN", value: record?.ern, name: "ern" },
                      { label: "Membership", value: record?.membership, name: "membership" },
                      { label: "# Females", value: record?.no_females, name: "no_females" },
                      { label: "# Males", value: record?.no_males, name: "no_males" },
                  ].map( val => {
                      return (
                        <TextDetail label={val.label} val={val.value} key={val.value} />
                      )
                  } )}
                </div> 
                {record?.status === "APPROVED" && <a className="bg-blue-500 text-xs text-white px-2 py-1 cursor-pointer" id={record?.id} onClick={requestRenewal}>Request for application renewal</a>}
              </Panel>

              <Panel label="Section C: Business Particulars">
                <div className="grid grid-cols-2 gap-2 items-center">
                  {[
                      { label: "Business Trading Name", value: record?.trading_name, name: "trading_name" },
                      { label: "Annual Turnover / Income", value: record?.annual_turnover, name: "annual_turnover" },
                      { label: "Service Type", value: record?.service_type, name: "service_type" },
                      { label: "Services ISIC", value: record?.service_name, name: "service_name" },
                      { label: "Company Certification", value: record?.company_certification, name: "company_certification" },
                      { label: "Website", value: record?.website, name: "website" },
                  ].map( val => {
                      return (
                        <TextDetail label={val.label} val={val.value} key={val.value} />
                      )
                  } )}
                </div> 
                {record?.status === "APPROVED" && <a className="bg-blue-500 text-xs text-white px-2 py-1 cursor-pointer" id={record?.id} onClick={requestRenewal}>Request for application renewal</a>}
              </Panel>

                
              <Panel label="Attachments">
                <table className="w-full border">
                  <thead className="text-xs bg-gray-200 font-bold p-2">
                      <th className="p-2">#</th>
                      <th>Name</th>
                      <th>Size</th>
                      <th>Action</th>
                      <th>Date Created</th>
                  </thead>
                  <tbody>
                      {files?.map( ( item, index ) => {
                          return (
                              <tr key={index} className="text-xs p-2 text-center">
                                  <td className="p-2">{`${index+1}`}</td>
                                  <td>{item.name}</td>
                                  <td>{item.size}</td>
                                  <td>
                                    <a className="bg-red-500 text-xs text-white px-2 py-1" href={item.file} download={item.name}>Download</a>
                                    <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.id} onClick={previewFile}>View File</a>
                                  </td>
                                  <td>{moment( item.created_at ).format("DD MMM, YYYY")}</td>
                              </tr>
                          )
                      } )}
                  </tbody>
                </table>
              </Panel>

              
              {/* <Panel label="Comments">
                <table className="w-full border">
                  <thead className="text-xs bg-gray-200 font-bold p-2">
                      <th className="p-2">#</th>
                      <th>Actor</th>
                      <th>Comments</th>
                      <th>Action</th>
                      <th>Date Created</th>
                  </thead>
                  <tbody>
                      {remarks?.map( ( item, index ) => {
                          return (
                              <tr key={index} className="text-xs p-2 text-center">
                                  <td className="p-2">{`${index+1}`}</td>
                                  <td>{item.actioned_by}</td>
                                  <td>{item.comments}</td>
                                  <td>{item.action}</td>
                                  <td>{moment( item.created_at ).format("DD MMM, YYYY")}</td>
                              </tr>
                          )
                      } )}
                  </tbody>
                </table>
              </Panel> */}
            </div>
          </div>
        </div> ) }
    </Wrapper>
  )
}

